exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ExtraInfo-module__wrapper___3nU6p .ExtraInfo-module__bottom-title___3JlGN{text-align:center;font-size:14px;color:#b4bac3;margin-bottom:1rem}.ExtraInfo-module__wrapper___3nU6p .ExtraInfo-module__grid___2RO-q{display:grid;gap:1rem;margin-bottom:1rem}.ExtraInfo-module__wrapper___3nU6p .ExtraInfo-module__button___gwpxL{display:flex;justify-content:center}.ExtraInfo-module__wrapper___3nU6p .ExtraInfo-module__extra-info-wrapper___2Lcih{display:grid;gap:1rem;width:100%}.ExtraInfo-module__wrapper___3nU6p .ExtraInfo-module__extra-info-wrapper___2Lcih .ExtraInfo-module__title___1rmQG{padding:.5rem;border:none;font-size:14px;border-radius:3px}", ""]);

// exports
exports.locals = {
	"wrapper": "ExtraInfo-module__wrapper___3nU6p",
	"bottom-title": "ExtraInfo-module__bottom-title___3JlGN",
	"grid": "ExtraInfo-module__grid___2RO-q",
	"button": "ExtraInfo-module__button___gwpxL",
	"extra-info-wrapper": "ExtraInfo-module__extra-info-wrapper___2Lcih",
	"title": "ExtraInfo-module__title___1rmQG"
};